import { useQuery } from "react-query";
import { getCamerasAndLocation } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useCamerasAndLocation = () => {
  const { data, isLoading, refetch } = useQuery(
    "GetCamerasAndLocation",
    getCamerasAndLocation,
    {
      refetchOnWindowFocus: false,
    }
  );

  return { data, isLoading, refetch };
};
